module.exports = __webpack_public_path__ + "img/points_mission.e7eb89a8.svg";